// src/components/sections/FAQSection.js
import { useState } from 'react';
import { useQuery } from 'react-query';
import { fetchFAQs } from '../../services/api';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeader } from '../ui';
import styles from './FAQSection.module.css';

function FAQItem({ item }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <div className={`${styles.item} ${open ? styles.open : ''}`}>
      <button className={styles.question} onClick={() => setOpen((v) => !v)}>
        <span>{t(item, 'question')}</span>
        <span className={styles.chevron}>{open ? '▲' : '▼'}</span>
      </button>
      {open && <div className={styles.answer}>{t(item, 'answer')}</div>}
    </div>
  );
}

export default function FAQSection() {
  const { ui } = useLang();
  const { data: faqs = [], isLoading } = useQuery('faqs', fetchFAQs, { staleTime: 1000 * 60 * 15 });

  return (
    <section className={styles.section} id="faq">
      <SectionHeader
        badge={ui('✦ سوالات متداول', '✦ FAQ')}
        title={ui('سوالات پرتکرار', 'Frequently Asked Questions')}
      />
      <div className={styles.list}>
        {isLoading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="skeleton" style={{ height: 56, borderRadius: 'var(--radius-md)' }} />
            ))
          : faqs.map((faq) => <FAQItem key={faq.id} item={faq} />)}
      </div>
    </section>
  );
}
